// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';

import { TypeModuleDO, TypeSensorDO } from '../../../requests';

interface Props {
  formValues: {
    data: Partial<TypeSensorDO>;
    typeModuleArray: TypeModuleDO[];
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export default class Form extends React.Component<Props> {
  public render(): JSX.Element {
    const { typeModuleArray, data } = this.props.formValues;

    return (
      <fieldset>
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Module</b> &nbsp;
            </label>
            <Select2
              name="typeModule.id"
              data={typeModuleArray.map((item: TypeModuleDO): DataSelect2 => {
                return { id: item.id, text: item.name };
              })}
              value={data.typeModule?.id}
              options={{
                placeholder: 'Select option',
              }}
              onChange={this.props.onChange}
              style={{ width: '80%' }}
            />
            <label>&nbsp;&nbsp;*</label>
          </div>
          <div className="col-6">
            <label className="label">
              &nbsp;
            </label>
            <input
              className="inputNew"
              type="checkbox"
              name="active"
              data-handler-type="boolean"
              checked={data.active || false}
              onChange={this.props.onChange}
            />
            &nbsp;&nbsp;
            <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
              Active
            </label>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Code</b> &nbsp; &nbsp; &nbsp;&nbsp;
            </label>
            <input
              className="inputNew"
              style={{ width: '80%' }}
              type="text"
              value={data.code}
              name="code"
              onChange={this.props.onChange}
              required
            />
            <label>&nbsp;&nbsp;*</label>
          </div>
          <div className="col-6">
            <label className="label">
              <b>Name</b> &nbsp; &nbsp;
            </label>
            <input
              className="inputNew"
              style={{ width: '80%' }}
              type="text"
              value={data.name}
              name="name"
              onChange={this.props.onChange}
              required
            />
            <label>&nbsp;&nbsp;*</label>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Type</b> &nbsp; &nbsp; &nbsp;&nbsp;
            </label>
            <input
              className="inputNew"
              style={{ width: '80%' }}
              type="text"
              value={data.type}
              name="type"
              maxLength={3}
              onChange={this.props.onChange}
              required
            />
            <label>&nbsp;&nbsp;*</label>
          </div>
          <div className="col-6">
            <label className="label">
              <b>Version</b> &nbsp; &nbsp;
            </label>
            <input
              className="inputNew"
              style={{ width: '150px' }}
              type="number"
              value={data.vers || 1}
              name="vers"
              onChange={this.props.onChange}
              required
            />
            <label>&nbsp;&nbsp;*</label>
          </div>
        </div>
      </fieldset>
    );
  }
}
